import type { AddEditAdditionalDepreciationFormProps } from '../components/modals/AddEditAdditionalDepreciation/form/types'
import type { AddEditAdditionalDepreciationRequestProps } from '@services/api/depreciation/types'

export const parseAdditionalDepreciationPayload = (formData: AddEditAdditionalDepreciationFormProps) => {
  const payload: AddEditAdditionalDepreciationRequestProps = {
    routeParams: {
      filiCode: formData.filiCode,
      id: formData.id
    },
    bodyParams: {
      competenceDate: formData.competenceDate,
      accountingCode: formData.accountNumber,
      accountingDescription: formData.accountDescriptionText,
      value: Number(formData.additionalDepreciationValue) || 0,
      observations: formData.observations.trim()
    }
  }

  return payload
}
